import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../_services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })

export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        
        var computerIdentifier = localStorage.getItem("computer");

        if (environment.login && !route.queryParams['computer'] && !computerIdentifier){
            const user = this.authenticationService.userValue;
            if (user) {
                // logged in so return true
                return true;
            }
    
            // not logged in so redirect to login page with the return url
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        } else {
            return true;
        }
      
    }
}

export const roleGuard = (required: string): CanActivateFn => {
  return () => {
    const raw = localStorage.getItem('user');
    if (!raw) return false;
    const u: any = JSON.parse(raw);
    if (!u?.token) return false;

    const payload = decodeJwt(u.token);
    const roles = Array.isArray(payload.role) ? payload.role : (payload.role ? [payload.role] : []);
    return roles.includes(required);
  };
};

function decodeJwt(token: string): any {
  const payload = token.split('.')[1];
  return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
}


